import { MapPin } from 'lucide-react';
import Lottie from 'lottie-react';
import suitcaseAnimation from '../../assets/suitcase-animation.json';

/* ── Testimonials data ── */
const testimonials = [
  { text: "Avant Speak&Move, je ne savais pas par où commencer. Maintenant j'ai une méthode claire : apprendre l'allemand, préparer mes dossiers et cibler les bons métiers. Je me sens enfin prête pour l'Ausbildung.", name: "Mireille", age: "23 ans", city: "Douala", photo: "https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/q3tnjvqx_Mireille.png" },
  { text: "Les vidéos m'ont aidé à comprendre les exigences réelles de l'Ausbildung. J'ai structuré mon CV en allemand et je révise chaque jour. Je vois déjà mes progrès.", name: "Arnaud", age: "28 ans", city: "Yaoundé", photo: "https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/22ajdzxu_Arnaud.png" },
  { text: "Je pensais que l'Ausbildung était inaccessible. Speak&Move m'a montré que c'est possible avec discipline. J'ai commencé mon A2 et je prépare mes candidatures.", name: "Prisca", age: "21 ans", city: "Bafoussam", photo: "https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/423o9m6y_Prisca.png" },
  { text: "Grâce aux conseils pratiques, j'ai compris comment présenter mon expérience et mes motivations. Je suis maintenant en train de finaliser mon dossier pour les entreprises allemandes.", name: "Junior", age: "29 ans", city: "Douala", photo: "https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/jqhdcp4e_Junior.png" },
  { text: "Speak&Move m'a donné une vision réaliste : apprendre l'allemand sérieusement, préparer mes documents et respecter les étapes. Je suis motivée pour atteindre le niveau B1.", name: "Aïcha", age: "25 ans", city: "Garoua", photo: "https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/7pvy4g3q_A%C3%AFcha.png" },
  { text: "J'étais perdu entre les démarches, les niveaux de langue et les documents. Maintenant tout est clair. Je suis un plan étape par étape pour réussir mon projet Ausbildung.", name: "Steve", age: "30 ans", city: "Kribi", photo: "https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/dltj0zzt_Steve.png" },
  { text: "Ce programme m'a aidée à organiser mon apprentissage de l'allemand et à comprendre les attentes des recruteurs. Je me sens enfin capable de postuler avec confiance.", name: "Nadine", age: "26 ans", city: "Yaoundé", photo: "https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/pu8yapnm_Nadine.png" },
];

const TestimonialCard = ({ testimonial }) => (
  <div className="flex-shrink-0 w-[380px] bg-white rounded-2xl p-6 shadow-sm">
    <div className="mb-5">
      <span className="text-4xl text-primary/20 font-serif leading-none">"</span>
      <p className="text-gray-700 text-sm leading-relaxed -mt-2">{testimonial.text}</p>
    </div>
    <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
      <img src={testimonial.photo} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border-2 border-primary/20" />
      <div>
        <p className="font-semibold text-gray-900 text-sm">{testimonial.name}, {testimonial.age}</p>
        <p className="text-xs text-gray-500">{testimonial.city}</p>
      </div>
    </div>
  </div>
);

// Success stories data - Row 1 (scrolls right to left)
const successStoriesRow1 = [
  { photo: "https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/q3tnjvqx_Mireille.png", name: "Mireille", city: "Douala" },
  { photo: "https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/22ajdzxu_Arnaud.png", name: "Arnaud", city: "Yaoundé" },
  { photo: "https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/423o9m6y_Prisca.png", name: "Prisca", city: "Bafoussam" },
  { photo: "https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/jqhdcp4e_Junior.png", name: "Junior", city: "Douala" },
  { photo: "https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/7pvy4g3q_A%C3%AFcha.png", name: "Aïcha", city: "Garoua" },
  { photo: "https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/dltj0zzt_Steve.png", name: "Steve", city: "Kribi" },
  { photo: "https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/pu8yapnm_Nadine.png", name: "Nadine", city: "Yaoundé" },
];

const SuccessCard = ({ story }) => (
  <div className="flex-shrink-0 w-[200px] group">
    <div className="relative rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 group-hover:-translate-y-1">
      <img
        src={story.photo}
        alt={story.name}
        className="w-full h-[260px] object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-4">
        <h4 className="text-white font-semibold text-sm">{story.name}</h4>
        <p className="text-white/70 text-xs">{story.city}</p>
      </div>
    </div>
  </div>
);

// Suitcase Lottie Animation Component
const SuitcaseAnimation = () => {
  return (
    <div className="relative w-[300px] h-[300px] md:w-[400px] md:h-[400px]">
      <Lottie 
        animationData={suitcaseAnimation}
        loop={true}
        autoplay={true}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};

const ResultsSection = () => {
  return (
    <section id="resultats" className="bg-[#f9fafb]" data-testid="results-section">
      {/* Dark Stats Section */}
      <div className="bg-[#1a1a2e] py-16 md:py-24">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* Left - Text & Stats */}
            <div>
              <div className="flex items-center gap-2 mb-6">
                <div className="w-2 h-2 bg-primary rounded-full" />
                <span className="text-white/60 text-sm font-medium uppercase tracking-wider">
                  Notre Impact
                </span>
              </div>
              
              <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6">
                Faire grandir les talents africains
                <br />
                <span className="text-primary">au-delà des frontières</span>
              </h2>
              
              <p className="text-white/70 text-lg mb-12 max-w-lg">
                Speak&Move prépare, forme et soutient les étudiants d'Afrique francophone dans leur parcours vers l'Allemagne.
              </p>
              
              {/* Stats Row */}
              <div className="flex flex-wrap gap-8 md:gap-12">
                <div>
                  <p className="font-heading text-5xl md:text-6xl font-bold text-white">45</p>
                  <p className="text-white/50 text-sm mt-1">étudiants<br />partis</p>
                </div>
                <div>
                  <p className="font-heading text-5xl md:text-6xl font-bold text-white">94%</p>
                  <p className="text-white/50 text-sm mt-1">taux de visa<br />approuvé</p>
                </div>
                <div>
                  <p className="font-heading text-5xl md:text-6xl font-bold text-white">5</p>
                  <p className="text-white/50 text-sm mt-1">partis<br />ce semestre</p>
                </div>
              </div>
            </div>
            
            {/* Right - Suitcase Animation */}
            <div className="flex justify-center lg:justify-end">
              <SuitcaseAnimation />
            </div>
          </div>
        </div>
      </div>

      {/* ── Section unifiée : Témoignages + Galerie ── */}
      <div id="temoignages" className="bg-[#004aad] py-16 md:py-24 overflow-hidden" data-testid="testimonials-section">

        {/* Header témoignages */}
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 mb-12">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-16">
            <div>
              <span className="inline-block text-white/70 text-sm font-medium mb-4">Témoignages</span>
              <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
                Ce que disent<br />
                <span className="italic font-normal text-yellow-300">nos étudiants ?</span>
              </h2>
            </div>
            <div className="flex items-end">
              <p className="text-white/80 text-lg max-w-md">
                Leurs réussites témoignent de la qualité de notre accompagnement. Ils ont transformé leur projet en réalité. Leurs histoires parlent mieux que n'importe quelle promesse.
              </p>
            </div>
          </div>
        </div>

        {/* Témoignages texte défilants */}
        <div className="relative mb-16">
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#004aad] to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#004aad] to-transparent z-10 pointer-events-none" />
          <div className="testimonials-track flex gap-6 animate-scroll">
            {testimonials.map((t, i) => (
              <TestimonialCard key={i} testimonial={t} />
            ))}
            {testimonials.map((t, i) => (
              <TestimonialCard key={`dup-${i}`} testimonial={t} />
            ))}
          </div>
        </div>

        {/* Galerie photos défilante */}
        <div className="relative overflow-hidden">
          <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-[#004aad] to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-[#004aad] to-transparent z-10 pointer-events-none" />
          <div className="success-gallery-track flex gap-4 animate-scroll-gallery">
            {successStoriesRow1.map((story, index) => (
              <SuccessCard key={index} story={story} />
            ))}
            {successStoriesRow1.map((story, index) => (
              <SuccessCard key={`dup-${index}`} story={story} />
            ))}
          </div>
        </div>

      </div>

      {/* Animation styles */}
      <style>{`
        .success-gallery-track,
        .success-gallery-track-reverse {
          width: max-content;
        }
        
        @keyframes scroll-gallery {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        
        @keyframes scroll-gallery-reverse {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
        
        .animate-scroll-gallery {
          animation: scroll-gallery 40s linear infinite;
          transition: animation-duration 0.5s ease-out;
        }
        
        .animate-scroll-gallery-reverse {
          animation: scroll-gallery-reverse 45s linear infinite;
          transition: animation-duration 0.5s ease-out;
        }
        
        .success-gallery-track:hover .animate-scroll-gallery,
        .success-gallery-track-reverse:hover .animate-scroll-gallery-reverse,
        .success-gallery-track:hover,
        .success-gallery-track-reverse:hover {
          animation-play-state: paused;
        }
        
        @keyframes pulse-dot {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.6; transform: scale(1.2); }
        }
        
        .animate-pulse-dot {
          animation: pulse-dot 2s ease-in-out infinite;
        }
        
        @keyframes dash {
          0% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: 100; }
        }
        
        .animate-dash {
          animation: dash 30s linear infinite;
        }
        
        .testimonials-track {
          width: max-content;
          animation: scroll-gallery 35s linear infinite;
        }
        .testimonials-track:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default ResultsSection;
